import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState } from "react";

import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";

import BottomSheetModal from "../BottomSheetModal";
    import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import { Images } from "assets";
import VText from "../VText";
import { useGlobalSearchParams } from "expo-router";
import ComingSoonCop from "components/ComingSoonCop";
import Pagination from "src/components/Pagination";
import Svg, { Circle, Path } from "react-native-svg";


export default React.forwardRef((props, ref) => {


    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();
    const local = useGlobalSearchParams();

    React.useImperativeHandle(ref, () => ({ show }), []);

    const show = () => {
        _bottomSheetRef?.current?.show();
    };



    const [header, setHeader] = useState("");
    const [subHeader, setSubHeader] = useState("");
    const [qrText, setQrText] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {

  
    }, []);

    const data = [
        {image: Images.aistylistImage1,},
        { image: Images.aistylistImage2, },
        {image: Images.aistylistImage3,},
       
    ];

    const _renderItem = ({ item, index }) => {
        const isActive = activeIndex === index;
        return (
            <Image
                source={item.image}
                accessibilityLabel={`AI Stylist Image ${index + 1}`}
                style={{ width: "100", height: "100%", opacity: isActive ? 1 : 0.5 }}
                resizeMode="contain"
            ></Image>
        );
    };


    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _bottomSheetRef?.current?.hide()}
            >
                
                <TouchableOpacity
                    style={{
                        width: wp(782),
                        height: hp(466),
                        height: "auto",
                        backgroundColor: "#fff",

                        // paddingTop: spV(30),
                        // paddingBottom: spV(15),
                        // paddingHorizontal: spH(40),
                        // overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <TouchableOpacity
                        onPress={() => _bottomSheetRef?.current?.hide()}
                        activeOpacity={0.8}
                        style={{
                            position: "absolute",
                            right: 20,
                            top: 20,
                            zIndex: 100,
                            // backgroundColor:"red"
                        }}
                    >
                        <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
                            <Path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                                fill="#212427"
                            />
                        </Svg>
                    </TouchableOpacity>
                    

                    <View style={{ flexDirection: "row" }}>
                        <View style={{ width: "55%", height: hp(466), backgroundColor: "black" }}>
                            <View style={{ alignItems: "center",  paddingTop: 55 }}>
                                <Carousel
                                    loop
                                    width={240}
                                    height={310}
                                    autoPlay={true}
                                    autoPlayInterval={2000}
                                    data={data}
                                    onConfigurePanGesture={(PanGesture) => {}}
                                    style={{ overflow: "visible" }}
                                    mode="parallax"
                                    modeConfig={{
                                        parallaxScrollingScale: 1,
                                        parallaxScrollingOffset: 100,
                                        parallaxAdjacentItemScale: 0.75,
                                    }}
                                    scrollAnimationDuration={1000}
                                    renderItem={_renderItem}
                                    onSnapToItem={(index) => setActiveIndex(index)}
                                    numberOfVisibleItems={3}
                                />

                  
                    <Pagination
                        backgroundColor="white"
                        data={Array.isArray(data) ? data : []}
                        selectedIndex={activeIndex}
                        containerStyle={{
                            width: "100px",
                            marginTop: spV(20),
                            paddingVertical: 14,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    />
                    </View> 
                        </View>
                        <View style={{ width: "45%", height: hp(466), backgroundColor: "white", alignItems: "center", justifyContent: "center" }}>
                                <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
                                        <Image accessibilityLabel="AI Stylist QR Code" source={Images.aiStylistDeeplinkQR} style={{ width: wp(120), height: hp(120) }} resizeMode="contain"></Image>
                                        <VText style={{ fontSize: fp(24), fontFamily: "LibreBodoni", color: "black",fontWeight: "400",marginTop: 10 }}>Chat with AI Stylist</VText>
                                        <VText style={{ fontSize: fp(16),lineHeight: 25, color: "black",fontWeight: "300",textAlign: "center",paddingHorizontal: 62,marginTop: 10 }}>
                                        From personalized product recommendations to personalized outfit styling.
                                        Scan the QR code to Download the Vêtir app.
                                        </VText>
                                       
                                </View>

                        </View>

                    </View>



                  


                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    image: {
        width: wp(309),
        height: hp(199),
    },
});
